import { useMemo, useState } from "react";
import { Link } from "react-router-dom";
import ArticleCard from "@/components/feature/ArticleCard";
import SectionHeading from "@/components/feature/SectionHeading";
import { articles } from "@/mocks/articles";

const tabs = [
  { key: "day", label: "今日热榜" },
  { key: "week", label: "本周热榜" },
];

export default function HotRanking() {
  const [tab, setTab] = useState("day");

  const list = useMemo(() => {
    if (tab === "day") {
      return [...articles].sort((a, b) => b.hot - a.hot).slice(0, 7);
    }
    return [...articles].sort((a, b) => b.comments - a.comments).slice(0, 7);
  }, [tab]);

  const featured = list[0];
  const rest = list.slice(1);

  return (
    <section className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
      <SectionHeading
        eyebrow="HOT LIST"
        title="热度榜 · 大家都在聊什么"
        desc="综合讨论量、搜索趋势与阅读时长加权得出，每两小时更新一次。"
        action={
          <div className="inline-flex rounded-full border border-background-200 bg-background-100 p-1">
            {tabs.map((t) => (
              <button
                key={t.key}
                type="button"
                onClick={() => setTab(t.key)}
                className={`whitespace-nowrap rounded-full px-4 py-2 text-sm transition-colors cursor-pointer ${
                  tab === t.key
                    ? "bg-primary-500 font-medium text-background-50"
                    : "text-foreground-600 hover:text-foreground-900"
                }`}
              >
                {t.label}
              </button>
            ))}
          </div>
        }
      />

      <div className="mt-10 grid grid-cols-1 gap-8 lg:grid-cols-12">
        <div className="rounded-lg border border-background-200 bg-background-50 p-5 md:p-6 lg:col-span-7">
          <ol>
            {rest.map((a, i) => (
              <li key={a.id}>
                <ArticleCard article={a} variant="rank" rank={i + 2} />
              </li>
            ))}
          </ol>
        </div>

        <div className="lg:col-span-5">
          <div className="mb-4 flex items-center gap-2 text-xs font-medium uppercase tracking-[0.2em] text-accent-700">
            <i className="ri-award-line text-lg"></i>
            编辑精选
          </div>
          <ArticleCard article={featured} />
          <Link
            to="/hot"
            className="mt-4 flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300 px-4 py-3 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-400 hover:text-primary-600 cursor-pointer"
          >
            查看完整榜单
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}